import { useCallback } from "react"
import { apiFetch } from "../../../utils/apiFetch"

export default function useAgendaPatientQuickActions({
  API_BASE,
  clinicId,
  quickPatient,
  setCreatingPatient,
  setQuickPatient,
  setPatientQuery,
  setNewAppt,
  loadPatients,
  isReadOnly,
  readOnlyReason
}) {
  const createQuickPatient = useCallback(async () => {
    if (isReadOnly) {
      alert(readOnlyReason || "Modo solo lectura activo")
      return
    }

    if (!clinicId || clinicId === "ALL") {
      alert("Selecciona una clínica válida")
      return
    }

    if (!quickPatient.firstName.trim() || !quickPatient.lastName.trim()) {
      alert("Nombre y apellido son obligatorios")
      return
    }

    try {
      setCreatingPatient(true)

      const res = await apiFetch(`${API_BASE}/appointments/quick-patient`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          clinicId,
          firstName: quickPatient.firstName,
          lastName: quickPatient.lastName,
          phone: quickPatient.phone,
          email: quickPatient.email
        })
      })

      const data = await res.json()

      if (!res.ok) {
        alert(data?.message || "No se pudo crear el paciente")
        return
      }

      setQuickPatient({
        firstName: "",
        lastName: "",
        phone: "",
        email: ""
      })

      setPatientQuery(`${data.firstName} ${data.lastName}`)
      setNewAppt((prev) => ({
        ...prev,
        patientId: data.id
      }))

      await loadPatients(clinicId, `${data.firstName} ${data.lastName}`)
      alert("Paciente creado correctamente")

      return data
    } catch {
      alert("Error al crear paciente")
    } finally {
      setCreatingPatient(false)
    }
  }, [
    isReadOnly,
    readOnlyReason,
    API_BASE,
    clinicId,
    quickPatient,
    setCreatingPatient,
    setQuickPatient,
    setPatientQuery,
    setNewAppt,
    loadPatients
  ])

  return {
    createQuickPatient
  }
}
